import CodeDesc from '../../code-desc';
import SupplierSelect from '../../supplier-select';

import type { TemplateOnlyComponent } from '@ember/component/template-only';
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

export interface ISkusSupplierFilterDefinitionArgs {
  skuId?: string;
  beforeQuery?: (query: IJsonApiQuery) => IJsonApiQuery;
}

interface FiltersSkusSupplierFilterSignature {
  Args: IFilterArgs<ISkusSupplierFilterDefinitionArgs>;
}

const FiltersSkusSupplierFilterComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <SupplierSelect
    @values={{@values}}
    @onChange={{@onChange}}
    @beforeQuery={{@componentArgs.beforeQuery}}
    @skuId={{@componentArgs.skuId}}
    @selectedPath='code'
    @labelHidden={{true}}
    @fill={{true}}
    @multiple={{true}}
    @matchTriggerWidth={{true}}
    @dataName={{@name}}
    ...attributes
    as |warehouse|
  >
    <CodeDesc @code={{warehouse.code}} @desc={{warehouse.description}} />
  </SupplierSelect>
</template> satisfies TemplateOnlyComponent<FiltersSkusSupplierFilterSignature>;

export default FiltersSkusSupplierFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::SkusSupplierFilter': typeof FiltersSkusSupplierFilterComponent;
    'filters/skus-supplier-filter': typeof FiltersSkusSupplierFilterComponent;
  }
}
